export const ORDER_BOOKS_ITEMS: number = 10;
